import React from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { ReposProvider } from './components/context/repos';
import { IdiomaProvider } from './components/context/IdiomaContext';
import './App.css';
import AnimatedRoutes from './components/AnimateRoutes';

function App() {
  return (
    <IdiomaProvider>
      <ReposProvider>
        <Router>
          <AnimatedRoutes />
        </Router>
      </ReposProvider>
    </IdiomaProvider>
  );
}

export default App;
